<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  conversation: { type: Object, required: true },
});

defineEmits(['click']);

const hasScheduledMessages = computed(
  () => props.conversation.has_pending_scheduled_messages
);

const scheduledCount = computed(
  () => props.conversation.pending_scheduled_messages?.length || 0
);
</script>

<template>
  <div
    v-if="hasScheduledMessages"
    v-tooltip.left="
      $t('CONVERSATION.CARD.SCHEDULED_MESSAGES', { count: scheduledCount })
    "
    class="relative flex items-center justify-center flex-shrink-0 rounded-full bg-n-amber-3 dark:bg-n-amber-4 size-5 cursor-pointer hover:bg-n-amber-4 dark:hover:bg-n-amber-5 transition-colors"
    @click.stop="$emit('click')"
  >
    <Icon icon="i-lucide-calendar-clock" class="size-3 text-n-amber-11" />
    <span
      v-if="scheduledCount > 0"
      class="absolute -top-1 -right-1 flex items-center justify-center size-3.5 rounded-full bg-n-amber-9 text-[10px] font-semibold text-white"
    >
      {{ scheduledCount > 9 ? '9+' : scheduledCount }}
    </span>
  </div>
</template>
